import { useContas } from "@/hooks/useContas";
import { LoadingScreen } from "@/components/layout/LoadingScreen";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Plus, Building2 } from "lucide-react";

export const ContasTab = () => {
  const { accounts, loading, showNew, setShowNew, newName, setNewName, newType, setNewType, createAccount } = useContas();

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-sm text-muted-foreground">Cuentas contables para gestión financiera</p>
        <Dialog open={showNew} onOpenChange={setShowNew}>
          <DialogTrigger asChild>
            <Button className="gap-2 glow-orange"><Plus className="w-4 h-4" />Nueva Cuenta</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nueva Cuenta Contable</DialogTitle></DialogHeader>
            <div className="space-y-4">
              <div className="space-y-2">
                <Label>Nombre</Label>
                <Input value={newName} onChange={e => setNewName(e.target.value)} className="bg-secondary border-transparent" />
              </div>
              <div className="space-y-2">
                <Label>Tipo</Label>
                <Select value={newType} onValueChange={setNewType}>
                  <SelectTrigger className="bg-secondary border-transparent"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="bank">Banco</SelectItem>
                    <SelectItem value="cash">Cajón</SelectItem>
                    <SelectItem value="card">Máquina tarjeta</SelectItem>
                    <SelectItem value="platform">Plataforma</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <DialogFooter><Button onClick={createAccount}>Crear</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      {loading ? <LoadingScreen /> : (
        <div className="grid gap-3">
          {accounts.map(c => (
            <Card key={c.id} className="card-hover">
              <CardContent className="flex items-center justify-between p-4">
                <div className="flex items-center gap-3">
                  <Building2 className="w-5 h-5 text-muted-foreground" />
                  <span className="font-medium">{c.name}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-bold">{c.balance.toFixed(2)}€</span>
                  <Badge variant="outline">{c.type}</Badge>
                </div>
              </CardContent>
            </Card>
          ))}
          {accounts.length === 0 && <p className="text-center text-muted-foreground py-8">Sin cuentas</p>}
        </div>
      )}
    </div>
  );
};
